module.exports = __webpack_public_path__ + "img/tc-1.09c90598.png";